import React from "react";
import { InputText } from "primereact/inputtext";
import { Controller } from "react-hook-form";
import { classNames } from "primereact/utils";

const EzControlledInputWithFloatingLabel = (props) => {
  const {
    control,
    name,
    disabled,
    type,
    rules,
    labelClassName,
    onChange,
    label,
    errorMsg,
    isError,
    step,
  } = props;

  const getLabelClassName = () => {
    return classNames({
      "p-error": isError,
      labelClassName,
    });
  };

  return (
    <div className="field">
      <span className="p-float-label">
        <Controller
          name={name}
          control={control}
          rules={rules}
          render={({ field, fieldState }) => (
            <InputText
              type={type}
              id={field.name}
              name={field.name}
              onChange={onChange}
              disabled={disabled}
              step={step}
              {...field}
              className={classNames({
                "p-invalid": fieldState.invalid,
              })}
            />
          )}
        />
        {label !== undefined ? (
          <label htmlFor={name} className={getLabelClassName()}>
            {rules?.required ? (
              <>
                {label}
                <span style={{ color: "red" }}>*</span>
              </>
            ) : (
              label
            )}
          </label>
        ) : (
          ""
        )}
      </span>
      {errorMsg}
    </div>
  );
};

EzControlledInputWithFloatingLabel.defaultProps = {
  labelClassName: "",
  disabled: false,
  type: "text",
};

export default EzControlledInputWithFloatingLabel;
